// Scores: the league's other games this week, on Game Day (DIRECTION U22,
// B-318). The scoreboard's own tiles (B-385), so a game reads the same here
// and there, each a tap from its matchup. The matchup on screen is left out:
// its card is the top of the page.

import { useAwards, useScoreboard } from '../../data/hooks';
import { EmptyState } from '../../kit';
import { FromLeague } from '../shared/FromLeague';
import { GameTile } from '../scoreboard/GameTile';
import '../../styles/screens/scoreboard.css';
import '../../styles/screens/game-day.css';

export function LeagueScores({
  period,
  exclude,
}: {
  /** The week on screen; undefined is now, the read the Scoreboard screen shares. */
  period: number | undefined;
  exclude: string;
}) {
  const awards = useAwards(period);
  return (
    <FromLeague snapshot={useScoreboard(period)}>
      {(board) => {
        const others = board.matchups.filter((m) => m.id !== exclude);
        return others.length === 0 ? (
          <EmptyState>No other games this week.</EmptyState>
        ) : (
          <div className="fsp-gd-scores">
            {others.map((m) => (
              <GameTile key={m.id} m={m} awards={awards?.perPeriod} stats={board.stats} />
            ))}
          </div>
        );
      }}
    </FromLeague>
  );
}
